import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Form, Input, Select } from 'antd';




import InputObject from '../../components/InputObject'

import TantsoriFederatsiiFilter from '../TantsoriFederatsiiFilter'
import TantsoriFederatsiiSelector from '../TantsoriFederatsiiSelector'

import CRUDE_RegionalnieOtdeleniya from '../../../objects/RegionalnieOtdeleniya/crude'
import REDUX_RegionalnieOtdeleniya from '../../../objects/RegionalnieOtdeleniya/reducer'

const { Option } = Select;
const { TextArea } = Input;


export default function PredlozhenieRukiISerdtsa(props) {
    const dispatch = useDispatch();
    const { auth, form } = props;
    const user = useSelector(state => state.home.user);

    const RegionalnieOtdeleniya = useSelector(REDUX_RegionalnieOtdeleniya.selector.array);
    useEffect(() => {
        form.resetFields();
        CRUDE_RegionalnieOtdeleniya.read(auth, (data) => {
            if (data.length > 0) {
                dispatch(REDUX_RegionalnieOtdeleniya.actions.setArray(data));
            }
        }, 'model', 's-nazvanie=ASC');
    }, []);
    const RegionalnieOtdeleniyaOptions = RegionalnieOtdeleniya.map(i => (
        <Option key={i.ID} value={i.ID}>{i.nazvanie}</Option>
    ));
    return (
        <>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    // shkolaID: object.ID
                }}
            >
                {user.gender.ID === 1 && 
                <Form.Item
                    name={"partnershaID"}
                    label={"Партнерша"}
                    rules={[{ required: true, message: 'Укажите партнершу!' }]}
                >
                    <InputObject auth={auth} 
                        title={"Поиск танцора"}
                        url={"/api/find/tantsorifederatsiifilter"}
                        object={{ Gender: 2 }}
                        searchForm={TantsoriFederatsiiFilter}
                        selectForm={TantsoriFederatsiiSelector} />
                </Form.Item>}
                {user.gender.ID === 2 && 
                <Form.Item
                    name={"partnerID"}
                    label={"Партнер"}
                    rules={[{ required: true, message: 'Укажите партнера!' }]}
                >
                    <InputObject auth={auth} 
                        title={"Поиск танцора"}
                        url={"/api/find/tantsorifederatsiifilter"}
                        object={{ Gender: 1 }}
                        searchForm={TantsoriFederatsiiFilter}
                        selectForm={TantsoriFederatsiiSelector} />
                </Form.Item>}
                <Form.Item
                    name={"regionalnoeOtdelenieID"}
                    label={"Региональное отделение"}
                    rules={[{ required: true, message: 'Укажите региональное отделение!' }]}
                >
                    <Select showSearch
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }>
                        {RegionalnieOtdeleniyaOptions}
                    </Select>
                </Form.Item>
                <Form.Item
                    name={"stsenicheskoeNazvaniePari"}
                    label={"Сценическое название пары"}
                    rules={[{ required: false, message: 'Укажите сценическое название пары!' }]}
                >
                    <TextArea rows={1} />
                </Form.Item>
            </Form>
        </>
    );
}
